import React from "react";
import MarketPulseEditor from "../ai/MarketPulseEditor"; // adjust path if needed

export default function MarketPulsePage() {
  const isLocal = window.location.hostname === 'localhost';
  const baseUrl = isLocal ? 'http://localhost:5000' : 'https://www.trendscout.club';
  const fetchUrl  = `${baseUrl}/api/marketpulse/list`;
  const saveUrl   = `${baseUrl}/api/marketpulse/upsert`;
  const deleteUrl = `${baseUrl}/api/marketpulse/delete`;
  const exportUrl = `${baseUrl}/api/marketpulse/export-xlsx`;

  return (
    <div className="tdh">

      <MarketPulseEditor
        fetchUrl={fetchUrl}
        saveUrl={saveUrl}
        deleteUrl={deleteUrl}
        exportUrl={exportUrl}
      />
    </div>
  );
}
